import { useState } from 'react';
import { useTheme } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { FakeLink } from '@hivebrite/design-system/Link';

import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import Info from 'hb-react/shared/icons/Info';

const ICON_SIZE = 20;

const RegistrationHelp = ({ enabled, headline, content, ...otherProps }) => {
  const theme = useTheme();

  const [isOpen, setIsOpen] = useState(false);

  if (!enabled) {
    return null;
  }

  return (
    <>
      <Box {...otherProps}>
        <Info
          height={ICON_SIZE}
          width={ICON_SIZE}
          fill={theme.colors.primary}
        />
        <Box ml={2}>
          <FakeLink font="h4-regular" onClick={() => setIsOpen(true)}>
            {headline}
          </FakeLink>
        </Box>
      </Box>
      {isOpen && (
        <ModalWithTemplate
          onCloseModal={() => setIsOpen(false)}
          screenReadersCloseButtonText={s__(
            'Accessibility|Close event registration help window',
          )}
          header=" " // Forces Header to be displayed so the content is positioned properly
        >
          <Box
            display="block"
            className="ckeditor-content--reset"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        </ModalWithTemplate>
      )}
    </>
  );
};

export default RegistrationHelp;
